"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultArea = void 0;
var defaultArea = 'default-area';
exports.defaultArea = defaultArea;